import React from 'react';

export default function HistorialHoy({ myDay, onSelectCanonical }) {
  const ingresos = myDay.ingresos || [];
  const salidas = myDay.salidas || [];

  if (ingresos.length <= 1 && salidas.length <= 1) {
    return null;
  }

  return (
    <section className="section">
      <h2 className="section-label">Marcas múltiples</h2>
      <div className="choose-card">
        {ingresos.length > 1 && (
          <Bloque titulo="Ingresos" marcas={ingresos} onSelect={onSelectCanonical} />
        )}
        {salidas.length > 1 && (
          <Bloque titulo="Salidas" marcas={salidas} onSelect={onSelectCanonical} />
        )}
      </div>
    </section>
  );
}

function Bloque({ titulo, marcas, onSelect }) {
  return (
    <div>
      <div style={{
        fontFamily: 'var(--mono)',
        fontSize: '0.66rem',
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        color: 'var(--brass)',
        marginBottom: 8
      }}>
        {titulo}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {marcas
          .slice()
          .sort((a, b) => a.timestamp_iso.localeCompare(b.timestamp_iso))
          .map((m) => (
            <div key={m.mark_id} className={`choose-row ${m.is_canonical ? 'canonical' : ''}`}>
              <div>
                <div className="ch-time">{formatHora(m.timestamp_iso)}</div>
                <div className="ch-meta">{m.modalidad || '—'} · {m.motivo || 'normal'}</div>
              </div>
              {m.is_canonical
                ? <span className="ch-mark">Válida</span>
                : <button className="ch-btn" onClick={() => onSelect(m.mark_id)}>Usar esta</button>
              }
            </div>
          ))}
      </div>
    </div>
  );
}

function formatHora(iso) {
  return new Date(iso).toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' });
}
